const META_APP_ID        = process.env.REACT_APP_META_APP_ID;
const META_LOGIN_CONFIG_ID = process.env.REACT_APP_META_LOGIN_CONFIG_ID;

let fbInitialized = false;

export const ensureFBSDKReady = () => {
  return new Promise((resolve, reject) => {
    if (window.FB && fbInitialized) return resolve(window.FB);

    let attempts = 0;
    const checkInterval = setInterval(() => {
      attempts++;
      if (window.FB) {
        if (!fbInitialized) {
          window.FB.init({
            appId:   META_APP_ID,
            cookie:  true,
            xfbml:   true,
            version: 'v20.0',
          });
          fbInitialized = true;
        }
        clearInterval(checkInterval);
        resolve(window.FB);
      } else if (attempts > 50) {
        clearInterval(checkInterval);
        reject(new Error('Facebook SDK no se cargó después de 5 segundos. Verifica tu conexión a internet.'));
      }
    }, 100);
  });
};

const makeSessionInfoListener = (callback) => {
  return (event) => {
    if (event.origin !== 'https://www.facebook.com' &&
        event.origin !== 'https://web.facebook.com') return;
    try {
      const data = JSON.parse(event.data);
      if (data.type === 'WA_EMBEDDED_SIGNUP' && callback) callback(data);
    } catch (_) {}
  };
};

export const launchEmbeddedSignupCoexistence = (sessionInfoCallback) => {
  return new Promise(async (resolve, reject) => {
    try {
      await ensureFBSDKReady();
    } catch (err) {
      return reject(err);
    }

    if (!META_LOGIN_CONFIG_ID) {
      return reject(new Error(
        'REACT_APP_META_LOGIN_CONFIG_ID no está configurado. ' +
        'El admin debe crear un Login Configuration en Meta App y agregar el ID al .env.'
      ));
    }

    const sessionListener = makeSessionInfoListener(sessionInfoCallback);
    window.addEventListener('message', sessionListener);

    window.FB.login(
      (response) => {
        window.removeEventListener('message', sessionListener);
        if (response.authResponse?.code) {
          resolve({ code: response.authResponse.code });
        } else {
          reject(new Error(
            response.error_message || 'Login cancelado. El usuario cerró el diálogo de Meta.'
          ));
        }
      },
      {
        config_id:                       META_LOGIN_CONFIG_ID,
        response_type:                   'code',
        override_default_response_type:  true,
        extras: {
          feature_type: 'whatsapp_business_app_onboarding',
          version:      3,
          setup:        {},
        },
      }
    );
  });
};

export const launchEmbeddedSignupCloudAPI = (sessionInfoCallback) => {
  return new Promise(async (resolve, reject) => {
    try {
      await ensureFBSDKReady();
    } catch (err) {
      return reject(err);
    }

    if (!META_LOGIN_CONFIG_ID) {
      return reject(new Error(
        'REACT_APP_META_LOGIN_CONFIG_ID no está configurado. ' +
        'El admin debe crear un Login Configuration en Meta App y agregar el ID al .env.'
      ));
    }

    const sessionListener = makeSessionInfoListener(sessionInfoCallback);
    window.addEventListener('message', sessionListener);

    window.FB.login(
      (response) => {
        window.removeEventListener('message', sessionListener);
        if (response.authResponse?.code) {
          resolve({ code: response.authResponse.code });
        } else {
          reject(new Error(
            response.error_message || 'Login cancelado. El usuario cerró el diálogo de Meta.'
          ));
        }
      },
      {
        config_id:                       META_LOGIN_CONFIG_ID,
        response_type:                   'code',
        override_default_response_type:  true,
        extras: {
          version: 3,
          setup:   {},
        },
      }
    );
  });
};
